var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.618528 4.28839L0 4.90692L2.16485 5.83471L3.09308 8L3.71161 7.38147L3.40234 5.83471L4.85155 4.3855L6.43068 7.75548L7.0164 7.16975L6.49586 2.74164L7.73291 1.50414C7.81647 1.42344 7.88312 1.3269 7.92897 1.22017C7.97482 1.11343 7.99896 0.998629 7.99997 0.882465C8.00098 0.766301 7.97884 0.6511 7.93485 0.543582C7.89086 0.436065 7.8259 0.338385 7.74376 0.256242C7.66162 0.174098 7.56394 0.109137 7.45642 0.0651481C7.3489 0.0211593 7.2337 -0.0009764 7.11754 3.30318e-05C7.00137 0.00104246 6.88657 0.0251768 6.77984 0.0710275C6.6731 0.116878 6.57656 0.183527 6.49586 0.267085L5.22599 1.53695L0.797875 1.01597L0.244524 1.56976L3.58825 3.17513L2.16529 4.5981L0.618528 4.28839Z",
    fill: "#5E43C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacationIcon);
export default __webpack_public_path__ + "static/media/vacation-icon.d033254e7ecf6c0cd15981d3502a1297.svg";
export { ForwardRef as ReactComponent };